const DUTCH_MONTHS = [
    'jan', 'feb', 'mrt', 'apr', 'mei', 'jun',
    'jul', 'aug', 'sep', 'okt', 'nov', 'dec',
]

const pad = (n) => String(n).padStart(2, '0')

/**
 * Datum en tijd van een gesprek, als '16 sep 2026, 11:12'.
 *
 * Met de hand opgebouwd en niet via `Intl`: de maandnamen liggen dan vast en
 * hangen niet af van de ICU-gegevens van de node waarmee de tests draaien.
 *
 * Een ontbrekende datum krijgt een aparte tekst en wordt nooit stilzwijgend nu.
 * Die tekst is in te stellen, zodat een sorteersleutel er '' van kan maken in
 * plaats van een streepje dat vóór alle letters sorteert.
 * AI-CONTEXT: See docs/pitfalls.md#ui-display-fallback-used-as-sort-key
 *
 * @param {number | null | undefined} timestampMs - epoch-ms
 * @param {string} [placeholder] - wat er staat als er geen bruikbare datum is
 * @returns {string}
 */
const formatConversationDate = (timestampMs, placeholder = '—') => {

    if (typeof timestampMs !== 'number' || !Number.isFinite(timestampMs)) return placeholder

    const date = new Date(timestampMs)
    if (Number.isNaN(date.getTime())) return placeholder

    return `${date.getDate()} ${DUTCH_MONTHS[date.getMonth()]} ${date.getFullYear()}, ${pad(date.getHours())}:${pad(date.getMinutes())}`
}

export default formatConversationDate
